import { safeDefine } from "@breuni-ui/safe-define";
import { Carousel } from "@breuni-ui/carousel";
import "../styles/entdContainer.scss";
import { entdCarouselTagName } from "./entdCarouselTagName";

const numberOfSlidesProperty: "--num-slides" = "--num-slides" as const;

const defaultNumberOfSlides: "3.5" = "3.5" as const;

export const numOfSlidesToChooseFrom: Map<number, string> = new Map([
  [0, "2.5"],
  [688, "3.5"],
  [1160, "4.5"],
  [1360, "5.5"],
  [1660, "6.5"],
  [1920, "7.5"],
]);

const descending: (a: number, b: number) => number = (a, b) => {
  if (a < b) {
    return 1;
  } else if (a > b) {
    return -1;
  } else {
    return 0;
  }
};

export const getNumSlidesForCurrentWidth: (
  containerWidth: number,
  numOfSlides: Map<number, string>,
) => string = (containerWidth, numOfSlides) => {
  const widthSpecKey = Array.from(numOfSlides.keys())
    .sort(descending)
    .find((width) => containerWidth >= width);
  if (widthSpecKey !== undefined && containerWidth !== Infinity) {
    return numOfSlides.get(widthSpecKey) || defaultNumberOfSlides;
  }
  return defaultNumberOfSlides;
};

export default class EntdCarousel extends Carousel {
  private resizeObserver: ResizeObserver;

  constructor() {
    super();
    this.resizeObserver = new ResizeObserver((_) => {
      const numOfSlides = getNumSlidesForCurrentWidth(
        this.offsetWidth,
        numOfSlidesToChooseFrom,
      );
      this.style.setProperty(numberOfSlidesProperty, numOfSlides);
    });
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.resizeObserver.observe(this);
    window.requestAnimationFrame(() => {
      const numOfSlides = getNumSlidesForCurrentWidth(
        this.offsetWidth,
        numOfSlidesToChooseFrom,
      );
      this.style.setProperty(numberOfSlidesProperty, numOfSlides);
    });
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.resizeObserver.disconnect();
  }
}

safeDefine(entdCarouselTagName, EntdCarousel);
